import { NextPage } from 'next';

import TemplateCentralDeAjuda from '@/templates/central-de-ajuda';

const CentralDeAjuda: NextPage = () => {
  return <TemplateCentralDeAjuda />;
};

export default CentralDeAjuda;
